/* eslint-disable no-unused-vars */
import CitiesService from '../../services/cities.service';
import ProvincesService from '../../services/provinces.service';
/* eslint-enable no-unused-vars */

export default class CitySelectorController {
  static $inject = ['ProvincesService', 'CitiesService', '$scope'];
  CitiesService: CitiesService;
  ProvincesService: ProvincesService;
  $scope: any;
  onUpdate: any;
  cityId: number;
  city: any;
  province: any;
  searchProvinceText: string;

  constructor(ProvincesService, CitiesService, $scope) {
    Object.assign(this, {
      ProvincesService,
      CitiesService,
      $scope
    });
  }

  $onInit() {
    this.updateCityProvince();
  }

  async updateCityProvince() {
    if (this.cityId) {
      const city = await this.CitiesService.findById(this.cityId, {
        include: ['province']
      });
      this.$scope.$apply(() => {
        this.city = city;
        this.province = city.province;
      });
    } else {
      const staFeProvince = await this.ProvincesService.findOne({
        filter: {
          where: {
            name: 'Santa Fe'
          }
        }
      });
      this.province = staFeProvince;
    }
  }

  async searchProvince(text: string) {
    return this.ProvincesService.find({
      where: {
        name: {
          ilike: `%${text}%`
        }
      }
    });
  }

  async searchCity(text: string) {
    return this.CitiesService.find({
      where: {
        name: {
          ilike: `%${text}%`
        },
        provinceId: this.province.id
      }
    });
  }

  onProvinceChange(province: any) {
    if (province && this.city && province.id != this.city.provinceId) {
      this.city = null;
    }
  }

  onCityChange(city: any) {
    if (city) {
      this.onUpdate({
        $event: {
          cityId: city.id,
          cityName: city.name,
          provinceId: this.province.id,
          provinceName: this.province.name
        }
      });
    }
  }
}
